import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import dayjs from "dayjs";
import { GiMoneyStack } from "react-icons/gi";

import { FaDownload, FaPaperPlane } from "react-icons/fa";
import { toast } from "react-toastify";
import logo from "../../Asset/logo.png";
import LoadingSpinner from "../../component/Loader/LoadingSpinner";
import { AdminCashier, OnlyAdmin } from "../../Protect/HiddenLink";
import {
  useGetOrdersByDateTimeRangeMutation,
  useLazyGetCompleteOrderQuery,
} from "../../redux/features/order/orderApi";
import { useDebounce } from "use-debounce";
import DatePicker from "react-multi-date-picker";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/features/auth/AuthSlice";

const Receipt = () => {
 const user = useSelector(selectUser);
  const [values, setValues] = useState(null);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1500);
  const startStr = values?.[0];
  const endStr = values?.[1];
  const startDateFilter = startStr ? new Date(startStr) : null;
  const endDateFilter = endStr ? new Date(endStr) : null;
  const [
    triggerGetOrders,
    { data: last7DayOrder, isLoading: orderLoading, isFetching: orderFetching },
  ] = useLazyGetCompleteOrderQuery();
  const orders = last7DayOrder?.data;

   const displayedOrders =
  user?.role === "counter"
    ? orders?.slice(0, 30) // latest 30
    : orders;


  useEffect(() => {
    triggerGetOrders({
      search: debouncedSearch,
      startDate: startDateFilter?.toISOString(),
      endDate: endDateFilter?.toISOString(),
    });
  }, []);

  const handleFetchOrders = () => {
    triggerGetOrders({
      search: debouncedSearch,
      startDate: startDateFilter?.toISOString(),
      endDate: endDateFilter?.toISOString(),
    });
  };

  const [
    getOrdersByDateTimeRange,
    { isLoading: reportLoading, isFetching: reportFetching },
  ] = useGetOrdersByDateTimeRangeMutation();

  const [groupedOrders, setGroupedOrders] = useState({});
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [visibleDates, setVisibleDates] = useState({});
  const [selectedOption, setSelectedOption] = useState("allDetails");
  const [dates, setDates] = useState({
    startDate: "",
    endDate: "",
  });

  const [report, setReport] = useState("summary");
  const printRef = useRef();

  const companyName = process.env.REACT_APP_COMPANY_NAME;
  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;
  const serviceCharges = process.env.REACT_APP_SERVICE_CHARGES;

  const handleDateChange = (event) => {
    const { name, value } = event.target;
    setDates((prevDates) => ({
      ...prevDates,
      [name]: value,
    }));
  };

  const [reportByDate, setReportByDate] = useState(null);
  const [detailReportData, setDetailReportData] = useState(null);

  const handleClick = async () => {
    if (!dates.startDate || !dates.endDate) {
      toast.error("Start and End Date both are requried");
      return;
    }
    const orderData = {
      startDate: dates.startDate,
      endDate: dates.endDate,
    };
    try {
      const response = await getOrdersByDateTimeRange(orderData).unwrap();
      if (response.success) {
        setReportByDate(response.reportData);
        setDetailReportData(response.detailReportData);
      }
    } catch (err) {
      toast.error(err?.data?.message || err?.data);
    }
  };

  const toggleDateVisibility = (date) => {
    setVisibleDates((prev) => ({
      // ...prev,
      [date]: !prev[date],
    }));
  };

  useEffect(() => {
    if (displayedOrders && displayedOrders.length > 0) {
      const grouped = displayedOrders.reduce((acc, order) => {
        const orderDate = dayjs(order.createdAt).format("D MMMM YYYY (dddd)");
        if (!acc[orderDate]) {
          acc[orderDate] = [];
        }
        acc[orderDate].push(order);
        return acc;
      }, {});

      setGroupedOrders(grouped);
    }
  }, [displayedOrders]);

  const handleOrderClick = (order) => {
    setSelectedOrder(order);
    setDetailReportData(null);
    setReportByDate(null);
    setDates({
      startDate: "",
      endDate: "",
    });
  };

  const componentPDF = useRef();
  const printStyles = `
  @media print {
    body {
      margin: 0;
      padding: 0;
      
    }
    html, body {
      height: auto;
      width: 100%;
      overflow: hidden;
    }
    * {
      page-break-inside: avoid;
    }
    @page {
      size: auto; 
      margin: 0;
    }
  }
`;
  const generatePDF = () => {
    const printContent = componentPDF.current;
    if (!printContent) return;

    // Clone the styles from the current document
    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          return Array.from(sheet.cssRules)
            .map((rule) => rule.cssText)
            .join("\n");
        } catch (err) {
          return ""; // Ignore CORS-restricted stylesheets
        }
      })
      .join("\n");

    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Print PDF</title>
          <style>${styles}</style>
        </head>
        <body class="p-4">${printContent.innerHTML}</body>
      </html>
    `);
    doc.close();

    iframe.contentWindow.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    };
  };

  const handlePrint = () => {
    const printContent = printRef.current;

    if (!printContent) return;

    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          return Array.from(sheet.cssRules)
            .map((rule) => rule.cssText)
            .join("\n");
        } catch (err) {
          return "";
        }
      })
      .join("\n");

    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Print PDF</title>
         <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet">
        <style>
          ${styles}  ${printStyles}
          body {
            font-family: 'Inter'; 
            color: #000;
            font-weight: medium;
          }
            .text-[.8rem]{
            font-size: 12px;
           
            }
            .text-[.7rem]{
            font-size: 11.2px;
           
            }
            .text-[.8rem]{
            font-size: 9.6px;
            
            }
        </style>
        </head>
        <body >${printContent.innerHTML}</body>
      </html>
    `);
    doc.close();

    iframe.contentWindow.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    };
  };

  const formatPKR = (amount) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 2,
    })
      .format(amount)
      .replace("PKR", "Rs.");
  };

  return (
    <>
      {(orderLoading || orderFetching || reportLoading || reportFetching) && (
        <LoadingSpinner />
      )}

      <div className="flex flex-col h-screen bg-[#F1F1F1]">
        <div>
          <Navbar page="Receipts" />
        </div>
        <div className="flex h-full overflow-hidden">
          <div className="lg:w-[30%] md:w-[39%] w-[35%] overflow-y-auto scrollbar-hide bg-white shadow-md">
            {/* <OrderList /> */}
            <div className="w-full flex flex-col">
              <input
                type="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="outline-none md:p-4 p-2 md:text-[1rem] text-[.7rem] w-full"
                placeholder="Search by order no"
              />
              <AdminCashier>
              <div className="flex items-center justify-between w-full">
                <DatePicker
                  value={values}
                  onChange={setValues}
                  range
                  rangeHover
                  format="YYYY/MM/DD"
                  render={(value, openCalendar) => (
                    <input
                      readOnly
                      onClick={openCalendar}
                      value={value}
                      placeholder="Select date range"
                      className="outline-none flex-grow p-2 md:text-[1rem] text-[.7rem] w-full"
                    />
                  )}
                />
                <button
                  className=" px-4 py-2 bg-[#0d868c] text-white  "
                  onClick={handleFetchOrders}
                >
                  Filter
                </button>
              </div></AdminCashier>
            </div>
            <div>
              {Object.entries(groupedOrders)?.map(([date, orders]) => (
                <div key={date}>
                  <div
                    onClick={() => toggleDateVisibility(date)}
                    className={`md:px-6 px-2 lg:px-8 bg-[#7D7D7D] text-white md:py-3 py-2 text-[9px] md:text-[11px] lg:text-[13px] font-bold cursor-pointer ${
                      visibleDates[date] ? "" : "border-b border-white"
                    }`}
                  >
                    {date}
                  </div>
                  <div
                    className={`overflow-hidden transition-max-height duration-500 ${
                      visibleDates[date] ? "h-max" : "max-h-0"
                    }`}
                  >
                    {orders.map((order) => (
                      <div
                        key={order._id}
                        onClick={() => handleOrderClick(order)}
                        className={`border-b md:px-6 px-2 lg:px-8 md:py-2 py-1.5 flex items-center cursor-pointer ${
                          selectedOrder && selectedOrder._id === order._id
                            ? "bg-[#0D868C] "
                            : ""
                        }`}
                      >
                        <GiMoneyStack
                          className={`md:size-8 size-5 md:mr-3 mr-1.5  ${
                            selectedOrder && selectedOrder._id === order._id
                              ? "text-white "
                              : "text-[#0D868C]"
                          }`}
                        />{" "}
                        <div className="order-info">
                          <div
                            className={`lg:text-[1rem] md:text-[.8rem] text-[.6rem] font-semibold ${
                              selectedOrder && selectedOrder._id === order._id
                                ? "text-white "
                                : "text-[#1E1E1E]"
                            }`}
                          >
                            {priceSymbol}{" "}
                            {order?.totalAmountDiscount > 0
                              ? (
                                  order?.totalAmountAfterDiscount +
                                  order.serviceCharges
                                ).toFixed(1)
                              : (
                                  order?.totalAmount + order.serviceCharges
                                ).toFixed(1)}
                          </div>
                          <div
                            className={`lg:text-[.75rem] md:text-[.6rem] text-[.5rem] font-semibold ${
                              selectedOrder && selectedOrder._id === order._id
                                ? "text-[white] "
                                : "text-[#A9A9A9]"
                            }`}
                          >
                            {dayjs(order.createdAt).format("h:mm A")}
                          </div>
                        </div>
                        <div
                          className={`ml-auto md:text-[.75rem] text-[.6rem] ${
                            selectedOrder && selectedOrder._id === order._id
                              ? "text-[white] "
                              : "text-[#A9A9A9]"
                          }`}
                        >
                          #{order.orderNo}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* card */}
          <div className="flex-1 lg:p-8 py-6 overflow-y-auto  relative flex flex-col justify-between">
            <div className="lg:w-full w-[40rem] mx-auto ">
              {reportByDate?.totalOrder ? (
                <div className="flex flex-col justify-between gap-3 px-10">
                  <div className="flex justify-end">
                    <button
                      onClick={generatePDF}
                      className="flex justify-center w-max items-center text-[white] bg-[#0D868C] rounded-lg p-2 font-semibold gap-2"
                    >
                      {" "}
                      <FaDownload />
                      DownLoad
                    </button>
                  </div>

                  <div
                    ref={componentPDF}
                    style={{ width: "100%" }}
                    className=" lg:py-6 py-4 px-4 w-[80%] mx-auto bg-white shadow-md
                rounded-xl flex flex-col gap-4"
                  >
                    <div className="text-[#888787] flex flex-col w-[95%] mx-auto">
                      <div className="flex justify-between">
                        {companyName && (
                          <p className="text-2xl text-[#575656] font-extrabold">
                            {companyName}
                          </p>
                        )}
                        <img src={logo} className="w-14 ml-auto" alt="" />
                      </div>

                      <p>
                        Start Date:{" "}
                        {dayjs(dates.startDate).format("YYYY-MM-DD hh:mm A")}
                      </p>
                      <p>
                        End Date:{" "}
                        {dayjs(dates.endDate).format("YYYY-MM-DD hh:mm A")}
                      </p>
                    </div>
                    <div className="w-[95%] mx-auto">
                      <select
                        value={report}
                        onChange={(e) => setReport(e.target.value)}
                        className="outline-none w-max text-[#888787] text-[12px] font-semibold border-b border-[#797979] "
                      >
                        <option value="summary">Report Summary</option>
                        <option value="detail">Report Detail</option>
                      </select>
                    </div>
                    {/* report table */}
                    {report === "summary" ? (
                      <table className=" border-collapse border w-[95%] mx-auto border-gray-300">
                        <thead>
                          <tr className="bg-gray-100">
                            <th className="border border-gray-300 px-4 py-2 text-left">
                              Label
                            </th>
                            <th className="border border-gray-300 px-4 py-2 text-left">
                              Quantity
                            </th>
                            <th className="border border-gray-300 px-4 py-2 text-left">
                              Total Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="border border-gray-300 px-4 py-2 capitalize">
                              {reportByDate?.ordersByCard?.amountType}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {reportByDate?.ordersByCard?.orders}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {formatPKR(reportByDate?.ordersByCard?.amount)}
                            </td>
                          </tr>
                          <tr>
                            <td className="border border-gray-300 px-4 py-2 capitalize">
                              {reportByDate?.ordersByCash?.amountType}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {reportByDate?.ordersByCash?.orders}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {formatPKR(reportByDate?.ordersByCash?.amount)}
                            </td>
                          </tr>
                          <tr>
                            <td className="border border-gray-300 px-4 py-2 capitalize">
                              {reportByDate?.ordersByOnline?.amountType}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {reportByDate?.ordersByOnline?.orders}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {formatPKR(reportByDate?.ordersByOnline?.amount)}
                            </td>
                          </tr>
                          <tr>
                            <td className="border border-gray-300 px-4 py-2 capitalize">
                              {reportByDate?.totalOrder?.amountType}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {reportByDate?.totalOrder?.orders}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {formatPKR(reportByDate?.totalOrder?.amount)}
                            </td>
                          </tr>

                          <tr>
                            <td className="border border-gray-300 px-4 py-2 capitalize">
                              Total Discount
                            </td>
                            <td className="border border-gray-300 px-4 py-2"></td>
                            <td className="border border-gray-300 px-4 py-2">
                              {formatPKR(reportByDate?.discount)}
                            </td>
                          </tr>

                          <tr>
                            <td className="border border-gray-300 px-4 py-2 capitalize">
                              Total Service Charges
                            </td>
                            <td className="border border-gray-300 px-4 py-2"></td>
                            <td className="border border-gray-300 px-4 py-2">
                              {formatPKR(reportByDate?.serviceCharges)}
                            </td>
                          </tr>
                          <tr>
                            <td className="border border-gray-300 px-4 py-2 capitalize">
                              Total Expense Out
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {reportByDate?.expensesData?.expenses}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {formatPKR(reportByDate?.expensesData?.amount)}
                            </td>
                          </tr>
                          <tr>
                            <td className="border border-gray-300 px-4 py-2 capitalize">
                              Total Cash In
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {reportByDate?.cashInData?.cashIns}
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              {formatPKR(reportByDate?.cashInData?.amount)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    ) : (
                      <div className="w-[95%] mx-auto">
                        <div className="flex items-center">
                          {[
                            "allDetails",
                            "orderDetails",
                            "expenseDetails",
                            "cashInDetails",
                            "itemsDetails",
                            "inventoryDetails",
                          ].map((option) => (
                            <label
                              key={option}
                              className={`flex items-center cursor-pointer ${
                                selectedOption === option
                                  ? "bg-blue-400"
                                  : "bg-gray-400"
                              }  p-2 border`}
                            >
                              <input
                                type="radio"
                                name="detailType"
                                value={option}
                                checked={selectedOption === option}
                                onChange={(e) =>
                                  setSelectedOption(e.target.value)
                                }
                                className="hidden"
                              />
                              <span className="capitalize md:text-[.85rem] text-[.7rem]">
                                {option.replace(/([A-Z])/g, " $1")}
                              </span>
                            </label>
                          ))}
                        </div>
                        {(selectedOption === "allDetails" ||
                          selectedOption === "orderDetails") && (
                          <>
                            <div className=" py-2 text-[.8rem] ">
                              <p className="text-center text-[1rem] font-semibold text-[#575656]">
                                Orders Details
                              </p>

                              {detailReportData?.orders?.length > 0 && (
                                <div className="flex justify-between items-center">
                                  <p>Total Orders Amount (Cash)</p>
                                  <p>
                                    {formatPKR(
                                      detailReportData?.orders
                                        ?.filter(
                                          (order) =>
                                            order.amountType === "cash",
                                        )
                                        .reduce(
                                          (total, order) =>
                                            total +
                                            (order.totalAmountDiscount > 0
                                              ? order.totalAmountAfterDiscount +
                                                order.serviceCharges
                                              : order.totalAmount +
                                                order.serviceCharges),
                                          0,
                                        ),
                                    )}
                                  </p>
                                </div>
                              )}

                              {detailReportData?.orders?.length > 0 && (
                                <div className="flex justify-between items-center">
                                  <p>Total Orders Amount (Card)</p>
                                  <p>
                                    {formatPKR(
                                      detailReportData?.orders
                                        ?.filter(
                                          (order) =>
                                            order.amountType === "card",
                                        )
                                        .reduce(
                                          (total, order) =>
                                            total +
                                            (order.totalAmountDiscount > 0
                                              ? order.totalAmountAfterDiscount +
                                                order.serviceCharges
                                              : order.totalAmount +
                                                order.serviceCharges),
                                          0,
                                        ),
                                    )}
                                  </p>
                                </div>
                              )}
                              {detailReportData?.orders?.length > 0 && (
                                <div className="flex justify-between items-center">
                                  <p>Total Orders Amount (Online)</p>
                                  <p>
                                    {formatPKR(
                                      detailReportData?.orders
                                        ?.filter(
                                          (order) =>
                                            order.amountType === "online",
                                        )
                                        .reduce(
                                          (total, order) =>
                                            total +
                                            (order.totalAmountDiscount > 0
                                              ? order.totalAmountAfterDiscount +
                                                order.serviceCharges
                                              : order.totalAmount +
                                                order.serviceCharges),
                                          0,
                                        ),
                                    )}
                                  </p>
                                </div>
                              )}
                              {detailReportData?.orders?.length > 0 && (
                                <div className="flex  justify-between items-center border-y border-gray-900 py-2">
                                  <p>Total Orders Amount</p>
                                  <p>
                                    {formatPKR(
                                      detailReportData?.orders?.reduce(
                                        (total, order) =>
                                          total +
                                          (order.totalAmountDiscount > 0
                                            ? order.totalAmountAfterDiscount +
                                              order.serviceCharges
                                            : order.totalAmount +
                                              order.serviceCharges),
                                        0,
                                      ),
                                    )}
                                  </p>
                                </div>
                              )}

                              {detailReportData?.orders?.length > 0 && (
                                <div className="flex  justify-between items-center">
                                  <p>Total Service Charges</p>
                                  <p>
                                    {formatPKR(
                                      detailReportData?.orders?.reduce(
                                        (total, order) =>
                                          total + Number(order.serviceCharges),
                                        0,
                                      ),
                                    )}
                                  </p>
                                </div>
                              )}

                              {detailReportData?.orders?.length > 0 && (
                                <div className="flex  justify-between items-center">
                                  <p>Total Discount</p>
                                  <p>
                                    {formatPKR(
                                      detailReportData?.orders?.reduce(
                                        (total, order) =>
                                          total +
                                          Number(order.totalAmountDiscount),
                                        0,
                                      ),
                                    )}
                                  </p>
                                </div>
                              )}
                            </div>
                            <div className="space-y-4">
                              <div className=" flex flex-col">
                                <div className="flex  items-center border  p-2 text-[.7rem] border-gray-900">
                                  <div className="w-[5%]">Sr #</div>
                                  <div className="w-[15%]">Order No</div>
                                  <div className="w-[20%]">Order Amount</div>
                                  <div className="w-[15%]">Discount</div>
                                  <div className="w-[25%]">Discount Note</div>
                                  <div className="w-[20%]">Charged Amount</div>
                                </div>
                                {detailReportData?.orders?.length > 0 &&
                                  detailReportData?.orders?.map((order, i) => (
                                    <div
                                      key={order.orderNo}
                                      className="flex items-center border border-t-0 border-gray-900 text-[.7rem] px-2 py-1"
                                    >
                                      <div className="w-[5%]">{i + 1}</div>
                                      <div className="w-[15%]">
                                        #{order.orderNo}
                                      </div>
                                      <div className="w-[20%]">
                                        {formatPKR(
                                          order.totalAmount +
                                            order.serviceCharges,
                                        )}
                                      </div>
                                      <div className="w-[15%]">
                                        {order.totalAmountDiscount > 0
                                          ? formatPKR(order.totalAmountDiscount)
                                          : "N/A"}
                                      </div>
                                      <div className="w-[25%] text-wrap capitalize">
                                        {order.discountReason
                                          ? order.discountReason.toLowerCase()
                                          : "N/A"}
                                      </div>
                                      <div className="w-[20%]">
                                        {formatPKR(
                                          order.totalAmountDiscount > 0
                                            ? order.totalAmountAfterDiscount +
                                                order.serviceCharges
                                            : order.totalAmount +
                                                order.serviceCharges,
                                        )}
                                      </div>
                                    </div>
                                  ))}

                                {/* {visibleOrders < detailReportData?.orders?.length ? (
                            <button
                              onClick={handleSeeMore}
                              className="mt-2 text-right text-[12px] underline hover:text-blue-600"
                            >
                              See More
                            </button>
                          ) : (
                            <button
                              onClick={handleSeeLess}
                              className="mt-2 text-right text-[12px] underline hover:text-blue-600"
                            >
                              See less
                            </button>
                          )} */}
                              </div>
                              {detailReportData?.orders?.length > 0 && (
                                <div className="flex  justify-between items-center border-y border-gray-900 py-2">
                                  <p>Total Orders Amount</p>
                                  <p>
                                    {formatPKR(
                                      detailReportData?.orders?.reduce(
                                        (total, order) =>
                                          total +
                                          (order.totalAmountDiscount > 0
                                            ? order.totalAmountAfterDiscount +
                                              order.serviceCharges
                                            : order.totalAmount +
                                              order.serviceCharges),
                                        0,
                                      ),
                                    )}
                                  </p>
                                </div>
                              )}
                              <p className="text-center text-[1rem] font-semibold text-[#575656] ">
                                100% Discount order
                              </p>

                              <div className=" flex flex-col">
                                <div className="flex  items-center border  p-2 text-[.7rem] border-gray-900">
                                  <div className="w-[5%]">Sr #</div>
                                  <div className="w-[15%]">Order No</div>
                                  <div className="w-[20%]">Order Amount</div>
                                  <div className="w-[15%]">Discount</div>
                                  <div className="w-[25%]">Discount Note</div>
                                  <div className="w-[20%]">Charged Amount</div>
                                </div>
                                {detailReportData?.freeOrders.map(
                                  (order, i) => (
                                    <div key={i}>
                                      <div className="flex  items-center border border-t-0 border-gray-900 text-[.7rem] px-2 py-1">
                                        <div className="w-[5%] ">{i + 1}</div>
                                        <div className="w-[15%] ">
                                          #{order.orderNo}
                                        </div>
                                        <div className="w-[20%] ">
                                          {formatPKR(
                                            order.totalAmount +
                                              order.serviceCharges,
                                          )}
                                        </div>
                                        <div className="w-[15%] ">
                                          {formatPKR(order.totalAmountDiscount)}
                                        </div>
                                        <div className="w-[25%] text-wrap capitalize ">
                                          {order.discountReason.toLowerCase()}
                                        </div>
                                        <div className="w-[20%]">0.00</div>
                                      </div>
                                    </div>
                                  ),
                                )}
                              </div>
                              {detailReportData?.freeOrders?.length > 0 && (
                                <div className="flex  justify-between items-center border-y border-gray-900 py-2">
                                  <p>Total 100% Discount order Amount</p>
                                  <p>
                                    {formatPKR(
                                      detailReportData?.freeOrders?.reduce(
                                        (total, order) =>
                                          total +
                                          (order.totalAmount +
                                            order.serviceCharges),
                                        0,
                                      ),
                                    )}
                                  </p>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                        {(selectedOption === "allDetails" ||
                          selectedOption === "expenseDetails") && (
                          <div className=" ">
                            <p className="text-center text-[1rem] font-semibold text-[#575656] py-2">
                              Expense Out
                            </p>

                            <div className=" flex flex-col text-[.8rem] ">
                              <div className="flex  items-center border mt-2  p-2 text-[.7rem] border-gray-900">
                                <div className="w-[5%]">Sr #</div>
                                <div className=" w-[75%]">Expense Note</div>
                                <div className="w-[20%]">Amount</div>
                              </div>
                              {detailReportData?.expenses?.map((expense, i) => (
                                <div className="flex  items-center border border-t-0 border-gray-900 text-[.7rem] px-2 py-1 ">
                                  <div className="w-[5%]">{i + 1}</div>
                                  <div className=" capitalize w-[75%]">
                                    {expense?.description}
                                  </div>
                                  <div className="w-[20%]">
                                    {formatPKR(expense?.balance)}
                                  </div>
                                </div>
                              ))}
                            </div>
                            {detailReportData?.expenses?.length > 0 && (
                              <div className="flex justify-between items-center mt-2 py-2 border-y border-gray-900 ">
                                <p>Total Expenses Amount</p>
                                <p>
                                  {formatPKR(
                                    detailReportData?.expenses?.reduce(
                                      (total, expense) =>
                                        total + expense.balance,
                                      0,
                                    ),
                                  )}
                                </p>
                              </div>
                            )}
                          </div>
                        )}
                        {(selectedOption === "allDetails" ||
                          selectedOption === "cashInDetails") && (
                          <div className=" ">
                            <p className="text-center text-[1rem] font-semibold text-[#575656] py-2">
                              Cash In
                            </p>

                            <div className=" flex flex-col ">
                              <div className="flex  items-center border mt-2  p-2 text-[.7rem] border-gray-900">
                                <div className="w-[5%]">Sr #</div>
                                <div className=" w-[75%]">Cash In Note</div>
                                <div className="w-[20%]">Amount</div>
                              </div>
                              {detailReportData?.cashes?.map((cash, i) => (
                                <div className="flex  items-center  border border-t-0 border-gray-900 text-[.7rem] px-2 py-1 ">
                                  <div className="w-[5%]">{i + 1}</div>
                                  <div className="w-[75%] capitalize">
                                    {cash?.description}
                                  </div>
                                  <div className="w-[20%]">
                                    {formatPKR(cash?.balance)}
                                  </div>
                                </div>
                              ))}
                            </div>
                            {detailReportData?.cashes?.length > 0 && (
                              <div className="flex justify-between items-center py-2 border-y border-gray-900 mt-2">
                                <p>Total Cash In Amount</p>
                                <p>
                                  {formatPKR(
                                    detailReportData?.cashes?.reduce(
                                      (total, cash) => total + cash.balance,
                                      0,
                                    ),
                                  )}
                                </p>
                              </div>
                            )}
                          </div>
                        )}
                        {(selectedOption === "allDetails" ||
                          selectedOption === "itemsDetails") && (
                          <div>
                            <div className="text-center text-[1rem] font-semibold text-[#575656] py-2">
                              Item Report
                            </div>
                            <div className=" flex flex-col w-full ">
                              <div className="flex  items-center border  mt-2  p-2 text-[.7rem] border-gray-900 ">
                                <div className="w-[5%]">Sr#</div>

                                <div className=" capitalize w-[40%]">Name</div>
                                <div className="w-[20%]">Price</div>
                                <div className="w-[15%]">Quantity</div>
                                <div className="w-[20%]">Total</div>
                              </div>
                              {detailReportData?.itemReport?.map(
                                (product, i) => (
                                  <div
                                    className={`flex  items-center p-2 text-[.7rem] border border-t-0 border-gray-900`}
                                  >
                                    <div className="w-[5%]">{i + 1}</div>

                                    <div className=" capitalize w-[40%]">
                                      {product?.name}
                                    </div>
                                    <div className="w-[20%]">
                                      {formatPKR(product?.price)}
                                    </div>
                                    <div className="w-[15%]">
                                      {product?.quantity}
                                    </div>
                                    <div className="w-[20%]">
                                      {formatPKR(
                                        product?.price * product?.quantity,
                                      )}
                                    </div>
                                  </div>
                                ),
                              )}
                            </div>
                            {detailReportData?.itemReport?.length > 0 && (
                              <div className="flex justify-between items-center py-2 border-y border-gray-900 mt-2">
                                <p>Total Sale Product Amount</p>
                                <p>
                                  {formatPKR(
                                    detailReportData?.itemReport?.reduce(
                                      (total, product) =>
                                        total +
                                        product?.price * product?.quantity,
                                      0,
                                    ),
                                  )}
                                </p>
                              </div>
                            )}
                          </div>
                        )}

                        {selectedOption === "inventoryDetails" && (
                          <div>
                            <div className="text-center text-[1rem] font-semibold text-[#575656] py-2">
                              Inventory Report
                            </div>
                            <div className=" flex flex-col  w-full ">
                              <div className="flex  items-center border border-b-0 mt-2  p-2 text-[.7rem] border-gray-900 ">
                                <div className="w-[5%]">Sr#</div>

                                <div className=" capitalize w-[40%]">Name</div>
                                <div className="w-[18.33%]">In</div>
                                <div className="w-[18.33%]">Out</div>
                                <div className="w-[18.33%]">Now</div>
                              </div>
                              {detailReportData?.inventoryInOutData?.items
                                ?.length > 0 && (
                                <div className="text-left border border-b-0  p-2 text-[1rem] border-gray-900 ">
                                  Item Details
                                </div>
                              )}
                              {detailReportData?.inventoryInOutData?.items?.map(
                                (product, i) => (
                                  <div
                                    key={i}
                                    className="flex  items-center p-2 text-[.7rem] border border-b-0 border-gray-900"
                                  >
                                    <div className="w-[5%]">{i + 1}</div>

                                    <div className=" capitalize w-[40%]">
                                      {product?.itemName}
                                    </div>
                                    <div
                                      title={`${product.itemIn} ${product.inventoryUnit}`}
                                      className="w-[18.33%]"
                                    >
                                      {product?.itemIn < product.conversionRate
                                        ? `${product.itemIn.toFixed(2)} ${
                                            product.inventoryUnit
                                          }`
                                        : `${(
                                            product.itemIn /
                                            product.conversionRate
                                          ).toFixed(2)}
                                  ${product.purchaseUnit}`}
                                    </div>
                                    <div
                                      title={`${product.itemOut} ${product.inventoryUnit}`}
                                      className="w-[18.33%]"
                                    >
                                      {" "}
                                      {product?.itemOut < product.conversionRate
                                        ? `${product.itemOut.toFixed(2)} ${
                                            product.inventoryUnit
                                          }`
                                        : `${(
                                            product.itemOut /
                                            product.conversionRate
                                          ).toFixed(2)}
                                      ${product.purchaseUnit}`}
                                    </div>
                                    <div
                                      title={`${product?.itemQuantity} ${product.inventoryUnit}`}
                                      className="w-[18.33%]"
                                    >
                                      {product?.itemQuantity <
                                      product.conversionRate
                                        ? `${product?.itemQuantity?.toFixed(
                                            2,
                                          )} ${product.inventoryUnit}`
                                        : `${(
                                            product?.itemQuantity /
                                            product.conversionRate
                                          ).toFixed(2)}
                                  ${product.purchaseUnit}`}
                                    </div>
                                  </div>
                                ),
                              )}
                              {detailReportData?.inventoryInOutData?.ingredients
                                ?.length > 0 && (
                                <div className="text-left border border-b-0  p-2 text-[1rem] border-gray-900 ">
                                  Ingredient Details
                                </div>
                              )}
                              {detailReportData?.inventoryInOutData?.ingredients?.map(
                                (ingredient, i) => (
                                  <div
                                    key={i}
                                    className={`flex  items-center p-2 text-[.7rem] border ${
                                      detailReportData?.inventoryInOutData
                                        ?.ingredients?.length -
                                        1 ===
                                      i
                                        ? ""
                                        : "border-b-0"
                                    }  border-gray-900`}
                                  >
                                    <div className="w-[5%]">{i + 1}</div>

                                    <div className=" capitalize w-[40%]">
                                      {ingredient?.ingredientName}
                                    </div>
                                    <div
                                      title={`${ingredient.ingredientIn} ${ingredient.inventoryUnit}`}
                                      className="w-[18.33%]"
                                    >
                                      {ingredient?.ingredientIn <
                                      ingredient.conversionRate
                                        ? `${ingredient.ingredientIn} ${ingredient.inventoryUnit}`
                                        : `${(
                                            ingredient.ingredientIn /
                                            ingredient.conversionRate
                                          ).toFixed(2)}
                                  ${ingredient.purchaseUnit}`}
                                    </div>
                                    <div
                                      title={`${ingredient.ingredientOut} ${ingredient.inventoryUnit}`}
                                      className="w-[18.33%]"
                                    >
                                      {" "}
                                      {ingredient?.ingredientOut <
                                      ingredient.conversionRate
                                        ? `${ingredient.ingredientOut} ${ingredient.inventoryUnit}`
                                        : `${(
                                            ingredient.ingredientOut /
                                            ingredient.conversionRate
                                          ).toFixed(2)}
                                  ${ingredient.purchaseUnit}`}
                                    </div>
                                    <div
                                      title={`${ingredient?.ingredientQuantity} ${ingredient.inventoryUnit}`}
                                      className="w-[18.33%]"
                                    >
                                      {ingredient?.ingredientQuantity <
                                      ingredient.conversionRate
                                        ? `${ingredient?.ingredientQuantity.toFixed(
                                            2,
                                          )} ${ingredient.inventoryUnit}`
                                        : `${(
                                            ingredient?.ingredientQuantity /
                                            ingredient.conversionRate
                                          ).toFixed(2)}
                                  ${ingredient.purchaseUnit}`}
                                    </div>
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ) : selectedOrder ? (
                <div>
                  <div className="flex justify-center items-center">
                    <div className="lg:py-6 py-4 px-4 w-[75%] lg:w-[60%] mx-auto bg-white shadow-md rounded-xl flex flex-col gap-4">
                      <div className="text-right">
                        <button
                          onClick={handlePrint}
                          className="bg-[#0d868c] text-white py-2 px-4 rounded-md w-max"
                        >
                          Print
                        </button>
                      </div>

                      {/* Top Section */}
                      <div className="w-full text-center">
                        <h1 className="lg:text-[2.75rem] text-[2rem] font-bold text-[#1E1E1E]">
                          {priceSymbol}{" "}
                          {Math.round(
                            selectedOrder?.totalAmountDiscount > 0
                              ? (
                                  selectedOrder?.totalAmountAfterDiscount +
                                  selectedOrder.serviceCharges
                                ).toFixed(2)
                              : (
                                  selectedOrder?.totalAmount +
                                  selectedOrder.serviceCharges
                                ).toFixed(2),
                          )}
                        </h1>
                        <h2 className="text-[#0D868C] lg:text-[1rem] text-[.8rem] font-bold capitalize">
                          Total paid
                        </h2>
                      </div>

                      {/* Lower Top Section */}
                      <div className="flex justify-between items-center border-y border-[#0D868C] lg:p-4 p-3">
                        <p className="text-[#1E1E1E] lg:text-[12px] text-[10px] font-normal">
                          Order Taken By:{" "}
                          <span className="capitalize">
                            {selectedOrder.username}
                          </span>
                        </p>
                        <p className="text-[#1E1E1E] lg:text-[14px] text-[12px] font-normal capitalize">
                          Table No: {selectedOrder.tableNo}
                        </p>
                      </div>
                      {/* Middle Section */}
                      <div>
                        {selectedOrder?.products?.map((item, index) => (
                          <div
                            key={item._id}
                            className={`flex items-center w-full lg:gap-6 gap-4 p-2 ${
                              index !== 0 ? "border-t border-[#DEDEDE]" : ""
                            }`}
                          >
                            <div className="flex flex-col flex-1 gap-1">
                              <h2 className="text-[#0D868C] text-[.8rem] lg:text-[1rem] font-semibold capitalize">
                                {item?.name}{" "}
                              </h2>
                              {item?.name?.includes("deal") && (
                                <h2 className="text-[#0D868C] text-[.7rem] capitalize">
                                  {item?.description}{" "}
                                </h2>
                              )}
                            </div>
                            <div className="flex items-center justify-between w-[35%] text-[#A9A9A9] text-[.8rem] lg:text-[1rem]">
                              <p className="w-[40%]">X{item.quantity}</p>
                              <p>
                                {priceSymbol}{" "}
                                {(item.price * item.quantity).toFixed(2)}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                      {/* Upper Lower Section */}
                      <div>
                        <p className="flex flex-col justify-between items-center lg:p-4 p-3 lg:text-[1rem] text-[.8rem] border-y-2 border-[#DEDEDE]">
                          {selectedOrder.totalAmountDiscount > 0 ? (
                            <div className="flex justify-between items-center w-full">
                              <span className="text-[#0D868C] font-bold">
                                Total
                              </span>
                              <span className="text-[#868585] flex gap-3 items-center ">
                                {priceSymbol}{" "}
                                <span className=" line-through text-[#c2c0c0]">
                                  {selectedOrder.totalAmount.toFixed(2)}
                                </span>
                                {selectedOrder.totalAmountAfterDiscount.toFixed(
                                  2,
                                )}
                              </span>
                            </div>
                          ) : (
                            <div className="flex justify-between items-center w-full">
                              <span className="text-[#0D868C] font-bold">
                                Total
                              </span>
                              <span className="text-[#868585]">
                                {priceSymbol}{" "}
                                {selectedOrder.totalAmount.toFixed(2)}
                              </span>
                            </div>
                          )}

                          {selectedOrder?.serviceCharges > 0 && (
                            <div className="flex justify-between items-center w-full text-[.8rem]">
                              <span className="text-[#0D868C] font-bold">
                                Service Charges{" "}
                                {selectedOrder?.serviceChargesPercentage
                                  ? selectedOrder?.serviceChargesPercentage
                                  : serviceCharges}
                                %
                              </span>
                              <span className="text-[#868585]">
                                {priceSymbol}{" "}
                                {selectedOrder?.serviceCharges?.toFixed(2)}
                              </span>
                            </div>
                          )}
                          {selectedOrder.charged > 0 && (
                            <div className="flex flex-col w-full text-[.8rem]">
                              <div className="flex justify-between items-center w-full">
                                <span className="text-[#0D868C] font-bold capitalize">
                                  {selectedOrder.amountType}
                                </span>
                                <span className="text-[#868585]">
                                  {priceSymbol}{" "}
                                  {selectedOrder.charged.toFixed(2)}
                                </span>
                              </div>
                              {selectedOrder.totalAmountDiscount > 0 ? (
                                <div className="flex justify-between items-center w-full">
                                  <span className="text-[#0D868C] font-bold">
                                    Paid
                                  </span>
                                  <span className="text-[#868585] flex gap-3 items-center ">
                                    {priceSymbol}
                                    {selectedOrder.totalAmountAfterDiscount.toFixed(
                                      2,
                                    )}
                                  </span>
                                </div>
                              ) : (
                                <div className="flex justify-between items-center w-full">
                                  <span className="text-[#0D868C] font-bold">
                                    Paid
                                  </span>
                                  <span className="text-[#868585]">
                                    {priceSymbol}{" "}
                                    {(
                                      selectedOrder.totalAmount +
                                      selectedOrder.serviceCharges
                                    ).toFixed(2)}
                                  </span>
                                </div>
                              )}
                              {selectedOrder.amountType.toLowerCase() ===
                                "cash" && (
                                <div className="flex justify-between items-center w-full">
                                  <span className="text-[#0D868C] font-bold">
                                    Change
                                  </span>
                                  <span className="text-[#868585]">
                                    {priceSymbol}{" "}
                                    {selectedOrder.returnAmount.toFixed(2)}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        </p>
                      </div>
                      {/* Lower Section */}
                      <div className="flex justify-between items-center text-[#A9A9A9] lg:text-[12px] text-[10px] lg:px-4 px-3 py-2">
                        <p>
                          {dayjs(selectedOrder.createdAt).format(
                            "D /M /YYYY . h:mm A",
                          )}
                        </p>
                        <p>#{selectedOrder.orderNo}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <p className="text-[#A9A9A9] pl-4">
                    Click on an order to view details.
                  </p>
                </div>
              )}
            </div>

            {/* Date Input Container */}
            <OnlyAdmin>
              <div className="lg:w-[80%] md:w-full w-[40rem]  mx-auto sticky bottom-0 left-0 px-4 flex justify-center  mt-8">
                <div className="bg-white/50 backdrop-blur  px-4 py-2 pb-[.9rem] w-full  rounded-full shadow-md flex  gap-2 items-end ">
                  <div className="w-full flex flex-col justify-center">
                    <label
                      htmlFor=""
                      className="text-[12px] pl-4 capitalize text-[#0D868C]"
                    >
                      start date
                    </label>

                    <input
                      type="datetime-local"
                      name="startDate"
                      value={dates.startDate}
                      onChange={handleDateChange}
                      className="w-full  p-2 bg-white/10 backdrop-blur-0 lg:text-[12px] text-[10px] text-[#0D868C] border rounded-full outline-none "
                    />
                  </div>
                  <div className="w-full flex flex-col justify-center">
                    <label
                      htmlFor=""
                      className="text-[12px] pl-4 capitalize text-[#0D868C]"
                    >
                      end date
                    </label>
                    <input
                      type="datetime-local"
                      name="endDate"
                      value={dates.endDate}
                      onChange={handleDateChange}
                      className="w-full p-2 bg-white/10 backdrop-blur-0 lg:text-[12px] text-[10px] text-[#0D868C] border rounded-full outline-none "
                    />
                  </div>
                  <button
                    onClick={handleClick}
                    className="bg-[#0D868C]  rounded-full lg:p-3 p-[10px] text-white"
                  >
                    <FaPaperPlane className="lg:size-6 size-4" />
                  </button>
                </div>
              </div>
            </OnlyAdmin>
          </div>
        </div>
        <div className="hidden invisible">
          <div ref={printRef} className="flex justify-center items-center ">
            <div className="bg-white mx-1 flex flex-col ">
              <div className="text-center mx-auto">
                <h1 className="w-full text-[1rem] text-center uppercase tracking-[.1em] ">
                  Restaurant Bill
                </h1>
              </div>

              <div className=" py-2  rounded-xl flex flex-col gap-1  ">
                {selectedOrder?.orderNo && (
                  <h1 className="w-full text-[.8rem] my-2 text-center uppercase tracking-[.1em] ">
                    Invoice #{selectedOrder.orderNo}
                  </h1>
                )}

                {/* Lower Top Section */}
                <div className="flex flex-col gap-1 border-y  border-[#000] py-1 px-1">
                  <p className="text-black text-[10px] uppercase tracking-[.1em] ">
                    Order Taken By:{" "}
                    <span className="capitalize">
                      {selectedOrder?.username}
                    </span>
                  </p>
                  <p className="text-black text-[10px] uppercase tracking-[.1em] ">
                    Table No: {selectedOrder?.tableNo}
                  </p>
                </div>

                {/* Middle Section */}
                <div className="border border-[#000]">
                  <div
                    className={`flex items-center w-full  border-b border-[#000]`}
                  >
                    <div className="flex items-center justify-between w-full text-black text-[.7rem]  tracking-[.1em]  ">
                      <p className="w-[30%]  text-center py-1">Qty</p>
                      <p className="w-[35%] border-x border-[#000] text-center py-1">
                        Rate
                      </p>
                      <p className="w-[35%]  text-center py-1">Total</p>
                    </div>
                  </div>
                  {selectedOrder?.products?.map((item, index) => (
                    <div
                      key={item._id}
                      className={`flex items-start flex-col w-full 
                      `}
                    >
                      <div className="flex flex-col flex-1 gap-1 pl-1">
                        <h2 className="text-black text-[.7rem]  uppercase tracking-[.1em] ">
                          {index + 1}. {item?.name}{" "}
                        </h2>
                        {item?.name?.includes("deal") && (
                          <h2 className="text-black text-[.6rem] uppercase tracking-[.1em] ">
                            {item?.description}{" "}
                          </h2>
                        )}
                      </div>
                      <div
                        className={`flex items-center justify-between w-full  ${
                          index !== selectedOrder?.products?.length - 1
                            ? "border-y"
                            : "border-t"
                        }  border-[#000] text-black text-[.7rem] uppercase tracking-[.1em]  `}
                      >
                        <p className="w-[30%] text-center ">{item?.quantity}</p>
                        <p className="w-[35%] border-x border-[#000] text-center ">
                          {item?.price}
                        </p>
                        <p className="w-[35%] text-center ">
                          {item?.price * item?.quantity}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Upper Lower Section */}
                <div>
                  <p className="flex flex-col justify-between items-center pb-2 pt-1 text-[.73rem]  border-t  border-[#000] ">
                    {selectedOrder?.serviceCharges > 0 && (
                      <div className="flex justify-between items-center w-full uppercase tracking-[.1em]  text-[.73rem]">
                        <span>
                          Service Charges{" "}
                          {selectedOrder?.serviceChargesPercentage
                            ? selectedOrder?.serviceChargesPercentage
                            : serviceCharges}
                          %
                        </span>
                        <span className="">
                          {priceSymbol}{" "}
                          {selectedOrder?.serviceCharges?.toFixed(2)}
                        </span>
                      </div>
                    )}
                    {selectedOrder?.totalAmount && (
                      <div className="flex justify-between items-center w-full uppercase tracking-[.1em] font-medium text-[.8rem]">
                        <span className=" ">Total</span>
                        <span className="">
                          {priceSymbol}{" "}
                          {(
                            selectedOrder?.totalAmount +
                            selectedOrder?.serviceCharges
                          ).toFixed(2)}
                        </span>
                      </div>
                    )}

                    {selectedOrder?.totalAmountDiscount > 0 && (
                      <div className="flex justify-between items-center text-[.73rem] w-full">
                        <span className="text-black uppercase tracking-[.1em] ">
                          Discount
                        </span>
                        <span className="text-black uppercase tracking-[.1em] ">
                          {priceSymbol}{" "}
                          {selectedOrder?.totalAmountDiscount.toFixed(2)}
                        </span>
                      </div>
                    )}

                    {selectedOrder?.totalAmountDiscount > 0 && (
                      <div className="flex justify-between items-center text-[.85rem] w-full border-t border-[#000]">
                        <span className="text-black uppercase tracking-[.1em] font-medium">
                          Grand Total
                        </span>
                        <span className="text-black uppercase tracking-[.1em] font-medium">
                          {priceSymbol}{" "}
                          {selectedOrder?.totalAmountDiscount > 0
                            ? (
                                selectedOrder?.totalAmountAfterDiscount +
                                selectedOrder?.serviceCharges
                              ).toFixed(2)
                            : (
                                selectedOrder?.totalAmount +
                                selectedOrder?.serviceCharges
                              ).toFixed(2)}
                        </span>
                      </div>
                    )}
                    {selectedOrder?.charged > 0 && (
                      <div className="flex flex-col w-full  ">
                        <div className="flex justify-between items-center uppercase tracking-[.1em]  w-full text-[.73rem]">
                          <span className="">{selectedOrder?.amountType}</span>
                          <span className="">
                            {priceSymbol} {selectedOrder?.charged?.toFixed(2)}
                          </span>
                        </div>

                        {selectedOrder?.amountType?.toLowerCase() === "cash" &&
                          selectedOrder?.returnAmount > 0 && (
                            <div className="flex justify-between items-center w-full uppercase tracking-[.1em]  text-[.73rem] border-t border-[#000]">
                              <span>Change</span>
                              <span>
                                {priceSymbol}{" "}
                                {selectedOrder?.returnAmount?.toFixed(2)}
                              </span>
                            </div>
                          )}
                      </div>
                    )}
                  </p>
                </div>

                <div className="text-[.75rem]  uppercase tracking-widest  text-center">
                  Thank You for Visiting
                </div>

                <div className="text-[.7rem] uppercase tracking-[.1em]  text-center w-full">
                  Powered By Eastern Tech
                  {/* <img src={ETLogo} alt="" /> */}
                </div>
                {/* Lower Section */}
                <div className="flex justify-center items-center text-black  text-[14px] uppercase tracking-[.1em]  pb-6">
                  <p>
                    {dayjs(selectedOrder?.createdAt).format(
                      "D /M /YYYY . h:mm A",
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Receipt;
